module.exports = __webpack_public_path__ + "img/project-2.70f67bff.png";